import { render } from "./SpecialHeader.vue?vue&type=template&id=782a1d53&scoped=true"
import script from "./SpecialHeader.vue?vue&type=script&lang=js"
export * from "./SpecialHeader.vue?vue&type=script&lang=js"

import "./SpecialHeader.vue?vue&type=style&index=0&id=782a1d53&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782a1d53"]])

export default __exports__